import React from 'react';

import Chip, { type ChipProps } from '@mui/material/Chip';

import Avatar from '@/components/mui/Avatar';

// The fields this dialog needs from a chat participant — a plain-object
// projection of the untyped `ChatUserFactory` Immutable Record
// (@/domain/chat/helpers.js), built at the selector boundary by the dialog.
export interface DialogUser {
  userId: string;
  username: string;
  picture: string;
}

interface EmailTagProps extends ChipProps {
  tag: string;
  users: Record<string, DialogUser>;
}

const EmailTag: React.FC<EmailTagProps> = ({ tag, users, ...rest }) => (
  <Chip
    // `name`, not `alt`: Avatar builds its own alt from `name` and ignores an
    // `alt` prop, so every chip used to announce itself as "avatar".
    avatar={<Avatar name={users[tag]?.username || tag} src={users[tag]?.picture} size={24} sx={{ ml: 0.5 }} />}
    variant="outlined"
    label={users[tag]?.username || tag}
    color="primary"
    {...rest}
  />
);

export default EmailTag;
